/*
 * @Author: Xu Chen
 * @Date: 2019-05-07 17:02:26
 * @Last Modified by: DK
 * @Last Modified time: 2019-09-29 10:06:43
 * @description: 作息策略
 */

import request from '@/plugin/axios';

export default {
  /* 根据班级获取作息策略 */
  getStrategy(payload) {
    return request({
      url: '/baseApi/schedules/getSchedules',
      method: 'post',
      data: payload
    });
  },

  /* 对班级设置作息策略 */
  setStrategy(payload) {
    return request({
      url: '/baseApi/schedules/addSchedules',
      method: 'post',
      data: payload
    });
  }
};
